import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../../base/Typography';
import AssistiveText from '../../base/AssistiveText';
import nerdwallet from './logos/nerdwallet.png';

import {
  CredentialContainer,
  CredentialHeadline,
  CredentialFooter,
} from './styles';

const getCredentialLogo = (credential) => {
  if (credential === 'nerdwallet') {
    return (
      <img alt="NerdWallet logo" height="20" width="122" src={nerdwallet} style={{ marginBottom: '1rem' }} />
    );
  }
  // TODO need a default logo
  return <img alt="NerdWallet logo" height="20" width="122" src={nerdwallet} style={{ marginBottom: '1rem' }} />;
};

export const CredentialCalloutComponent = ({
  headline,
  headlineAssistiveText,
  description,
  credential,
  isCredentialCitable,
  footer,
}) => (
  <CredentialContainer as={isCredentialCitable
    ? 'blockquote'
    : 'div'}>
    <CredentialHeadline
      component="h4"
      weight={300}
      color="color-primary-nm-blue"
      disableBottomPadding>
      {headline}&nbsp;
      <AssistiveText text={headlineAssistiveText.trim()} />
    </CredentialHeadline>
    <Typography component="p" color="color-neutral-black">
      {description}
    </Typography>
    {credential && getCredentialLogo(credential)}
    {footer && <CredentialFooter>{footer}</CredentialFooter>}
  </CredentialContainer>
);

CredentialCalloutComponent.propTypes = {
  headline: PropTypes.string.isRequired,
  headlineAssistiveText: PropTypes.string,
  description: PropTypes.any.isRequired,
  credential: PropTypes.oneOf(['nerdwallet']),
  isCredentialCitable: PropTypes.bool.isRequired,
  footer: PropTypes.any,
};

export default CredentialCalloutComponent;
